import React, { useState } from 'react';
import Layout from "../components/layout";
import Footer from '../components/footer';
import BgImage from '../images/bg/solutions-page-banner.jpg';
import SocialIconsFooter from '../components/social-icons-footer';
import { StaticImage } from 'gatsby-plugin-image';
import s1 from '../images/pragicts-software-development-process.png';
import myBIZ from '../images/icons/logo-light.png';
import myBIZ1 from '../images/bg/screenshot-mybiz-1.jpg';
import myBIZ2 from '../images/bg/screenshot-mybiz-2.jpg';
import myBIZ3 from '../images/bg/screenshot-mybiz-3.jpg';
import myBIZ4 from '../images/bg/screenshot-mybiz-4.jpg';
import myBIZ5 from '../images/bg/screenshot-mybiz-5.jpg';

const Test = () => {
  // Separate states for each project (expand/collapse state)
  const [isExpandedProject1, setIsExpandedProject1] = useState(false);
  const [isExpandedProject2, setIsExpandedProject2] = useState(false);

  const toggleContentProject1 = () => {
    setIsExpandedProject1(prevState => !prevState);
  };

  const toggleContentProject2 = () => {
    setIsExpandedProject2(prevState => !prevState);
  };

  return (
    <section data-scrollax-parent="true" id="projects">
      <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
        <span>//</span>OurShare
      </div>

      {/* First Project */}
      <div className="container main-about">
      <p style={{ fontWeight: 'bold', color: 'black' ,fontSize:'16px'}}>OurShare</p>
      <p style={{ paddingBottom: '30px',fontSize:'14px' }}>
      OurShare is PragICTS' unwavering commitment to Corporate Social Responsibility (CSR), where we focus on sharing our successes, expertise, and resources in ways that truly matter. As a responsible, ethical, and conscious company, we believe in playing an active role in making a difference—not only through our business practices but by contributing to the greater good of society. We aim to create a positive and lasting impact on our community, the environment, and the world at large.
        </p>

        <h2 style={{ fontSize:'20px' }}>Online Presence Implementation for MyBiz Sri Lanka.</h2>

        <p style={{ fontWeight: 'bold', color: 'black',fontSize:'16px' }}>Description</p>
        <p style={{ paddingBottom: '30px',fontSize:'14px' }}>
          myBIZ Sri Lanka is a company established as a Limited Liability by Guarantee, designed to function as a dynamic platform for business networking, with the primary goal of supporting small and medium-sized businesses (SMBs) in their growth and expansion. As part of this mission, PragICTS has played a key role in delivering a comprehensive, ground-up website implementation for myBIZ. This new digital platform, along with ongoing support and management, is aimed at strengthening myBIZ’s online presence and providing valuable resources for its membership.
        </p>

        {/* Container for content and button */}
        <div className="expandable-section">
          {/* Conditionally Render Content for Project 1 */}
          {isExpandedProject1 && (
            <div>
              <p style={{ fontWeight: 'bold', color: 'black',fontSize:'16px' }}>Organization</p>
              <p style={{ paddingBottom: '30px',fontSize:'14px' }}>
                myBIZ is a chamber dedicated to providing a platform for its members to share knowledge, and experience while promoting professionalism, best practices, and standards to foster growth and sustain business excellence.
              </p>

              <p style={{ fontWeight: 'bold', color: 'black',fontSize:'16px' }}>Website</p>
              <p style={{ paddingBottom: '30px',fontSize:'14px' }}>
                <a href="https://myBIZsl.lk">https://myBIZsl.lk</a>
              </p>

              <p style={{ fontWeight: 'bold', color: 'black' ,fontSize:'16px'}}>Client</p>
              <p style={{ paddingBottom: '30px',fontSize:'14px' }}>
                <img src={myBIZ} width={'200px'} alt="myBIZ logo" />
              </p>

              <p style={{ fontWeight: 'bold', color: 'black',fontSize:'16px' }}>Pictures</p>
              <img src={myBIZ1} className="responsive-image" alt="Business Image 1" />
              <img src={myBIZ2} className="responsive-image" alt="Business Image 2" />
              <img src={myBIZ3} className="responsive-image" alt="Business Image 3" />
              <img src={myBIZ4} className="responsive-image" alt="Business Image 4" />
              <img src={myBIZ5} className="responsive-image" alt="Business Image 5" />
            </div>
          )}

          {/* Expand/Collapse Button */}
          <button
            onClick={toggleContentProject1}
            className="expand-collapse-btn"
          >
            {isExpandedProject1 ? 'Collapse' : 'Expand'} 
          </button>
        </div>
      </div>

      {/* Second Project */}

      <div className="bg-parallax-module" data-position-top="50" data-position-left="20" data-scrollax="properties: { translateY: '-250px' }"></div>
      <div className="bg-parallax-module" data-position-top="40" data-position-left="70" data-scrollax="properties: { translateY: '150px' }"></div>
      <div className="bg-parallax-module" data-position-top="80" data-position-left="80" data-scrollax="properties: { translateY: '350px' }"></div>
      <div className="bg-parallax-module" data-position-top="95" data-position-left="40" data-scrollax="properties: { translateY: '-550px' }"></div>
      <div className="sec-lines"></div>
    </section>
  );
};

export default Test;


